import moment from 'moment';

// Network health icons
import { ReactComponent as NetworkHealthIcon } from '../../assets/NetworkHealthIcon.svg';
// Airplane health icons
import { ReactComponent as AirplaneHealthIcon } from '../../assets/AirplaneHealthIcon.svg';
import { ReactComponent as AirplaneOfflineIcon } from '../../assets/AirplaneOfflineIcon.svg';
// Software health icons
import { ReactComponent as SoftwareHealthIcon } from '../../assets/SoftwareHealthIcon.svg';
import { ReactComponent as SoftwareOfflineIcon } from '../../assets/SoftwareOfflineIcon.svg';
// Content health icons
import { ReactComponent as ContentHealthIcon } from '../../assets/ContentHealthIcon.svg';
import { ReactComponent as ContentOfflineIcon } from '../../assets/ContentOfflineIcon.svg';

export const getCardStyling = (cloudSystem, cloudType) => {
  switch (cloudType) {
    case 'fbo':
      return getCardStyling_FBO(cloudSystem);
    case 'cloudport':
      return getCardStyling_Cloudport(cloudSystem);
    case 'uncommissioned':
      return getCardStyling_Uncommissioned(cloudSystem);
    default:
      console.log('Unhandled cloudport type');
      return;
  }
};

const getCardStyling_FBO = (cloudSystem) => {
  
  const upTimeDiff = cloudSystem?.lastStatusUpdate ? moment().from(new Date(cloudSystem.lastStatusUpdate), true) : "Undetermined"

  // Set defaults for FBO
  // Default to HEALTHY/Offline case (only gray top-right icon for FBO)
  var styles = {
    textColor: '#FFFFFF',
    secondaryTextColor: '#AEB1B4',
    backgroundColor: '#0A1826',
    borderLeftColor: '#52B35B',
    networkHealthText: upTimeDiff,
    networkHealthIcon: <NetworkHealthIcon color='#AEB1B4' />,
    aircraftStatusColor: '#52B35B',
    aircraftIcon: <AirplaneHealthIcon color='#52B35B' />,
    softwareStatusColor: '#52B35B',
    softwareIcon: <SoftwareHealthIcon color='#52B35B' />,
    contentStatusColor: '#52B35B',
    contentIcon: <ContentHealthIcon color='#52B35B' />,
  };

  // Modify any varying fields

  switch (cloudSystem?.overallDeviceHealth) {
    case 'Healthy':
      styles.backgroundColor = '#0A1826';
      styles.borderLeftColor = '#52B35B';
      break;
    case 'Warning':
      styles.backgroundColor = '#434128';
      styles.borderLeftColor = '#EAAB00';
      break;
    case 'Error':
      styles.backgroundColor = '#4B2634';
      styles.borderLeftColor = '#D52D34';
      break;
    default:
      // Default to Healthy/offline case
      styles.backgroundColor = '#0A1826';
      styles.borderLeftColor = '#52B35B';
      break;
  }

  switch (cloudSystem?.networkHealth) {
    case 'Healthy':
      styles.networkHealthIcon = <NetworkHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.networkHealthIcon = <NetworkHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.networkHealthIcon = <NetworkHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for FBO
      styles.networkHealthIcon = <NetworkHealthIcon color='#52B35B' />;
      break;
  }

  switch (cloudSystem?.aircraftSyncHealth) {
    case 'Healthy':
      styles.aircraftStatusColor = '#52B35B';
      styles.aircraftIcon = <AirplaneHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.aircraftStatusColor = '#EAAB00';
      styles.aircraftIcon = <AirplaneHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.aircraftStatusColor = '#D52D34';
      styles.aircraftIcon = <AirplaneHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for FBO
      styles.aircraftStatusColor = '#52B35B';
      styles.aircraftIcon = <AirplaneHealthIcon color='#52B35B' />;
      break;
  }

  switch (cloudSystem?.visionContentHealth) {
    case 'Healthy':
      styles.contentStatusColor = '#52B35B';
      styles.contentIcon = <ContentHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.contentStatusColor = '#EAAB00';
      styles.contentIcon = <ContentHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.contentStatusColor = '#D52D34';
      styles.contentIcon = <ContentHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for FBO
      styles.contentStatusColor = '#52B35B';
      styles.contentIcon = <ContentHealthIcon color='#52B35B' />;
      break;
  }

  switch (cloudSystem?.softwareVersionHealth) {
    case 'Healthy':
      styles.softwareStatusColor = '#52B35B';
      styles.softwareIcon = <SoftwareHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.softwareStatusColor = '#EAAB00';
      styles.softwareIcon = <SoftwareHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.softwareStatusColor = '#D52D34';
      styles.softwareIcon = <SoftwareHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for FBO
      styles.softwareStatusColor = '#52B35B';
      styles.softwareIcon = <SoftwareHealthIcon color='#52B35B' />;
      break;
  }

  return styles;
};

const getCardStyling_Cloudport = (cloudSystem) => {

  const upTimeDiff = cloudSystem?.lastStatusUpdate ? moment().from(new Date(cloudSystem.lastStatusUpdate), true) : "Undetermined"

  // Set defaults for Cloudport
  // Default to Offline case 
  var styles = {
    textColor: '#FFFFFF',
    secondaryTextColor: '#AEB1B4',
    backgroundColor: '#0A1826',
    borderLeftColor: '#AEB1B4',
    networkHealthText: upTimeDiff,
    networkHealthIcon: <NetworkHealthIcon color='#AEB1B4' />,
    aircraftStatusColor: '#AEB1B4',
    aircraftIcon: <AirplaneOfflineIcon />,
    softwareStatusColor: '#AEB1B4',
    softwareIcon: <SoftwareOfflineIcon />,
    contentStatusColor: '#AEB1B4',
    contentIcon: <ContentOfflineIcon />,
  };

  if (isNetworkOnline(cloudSystem)) {
    styles.networkHealthIcon = <NetworkHealthIcon color='#52B35B' />;
  } else {
    // Cloudport is offline -- defaults are want we want
    // only thing to change is the symbol for the top-right icon
    styles.networkHealthIcon = <NetworkHealthIcon color='#AEB1B4' />;

    return styles;
  }

  // Modify any varying fields

  switch (cloudSystem?.overallDeviceHealth) {
    case 'Healthy':
      styles.backgroundColor = '#0A1826';
      styles.borderLeftColor = '#52B35B';
      break;
    case 'Warning':
      styles.backgroundColor = '#434128';
      styles.borderLeftColor = '#EAAB00';
      break;
    case 'Error':
      styles.backgroundColor = '#4B2634';
      styles.borderLeftColor = '#D52D34';
      break;
    default:
      // Default to Healthy case
      styles.backgroundColor = '#0A1826';
      styles.borderLeftColor = '#52B35B';
      break;
  }

  switch (cloudSystem?.aircraftSyncHealth) {
    case 'Healthy':
      styles.aircraftStatusColor = '#52B35B';
      styles.aircraftIcon = <AirplaneHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.aircraftStatusColor = '#EAAB00';
      styles.aircraftIcon = <AirplaneHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.aircraftStatusColor = '#D52D34';
      styles.aircraftIcon = <AirplaneHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for Cloudport
      styles.aircraftStatusColor = '#52B35B';
      styles.aircraftIcon = <AirplaneHealthIcon color='#52B35B' />;
      break;
  }

  switch (cloudSystem?.visionContentHealth) {
    case 'Healthy':
      styles.contentStatusColor = '#52B35B';
      styles.contentIcon = <ContentHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.contentStatusColor = '#EAAB00';
      styles.contentIcon = <ContentHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.contentStatusColor = '#D52D34';
      styles.contentIcon = <ContentHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for Cloudport
      styles.contentStatusColor = '#52B35B';
      styles.contentIcon = <ContentHealthIcon color='#52B35B' />;
      break;
  }

  switch (cloudSystem?.softwareVersionHealth) {
    case 'Healthy':
      styles.softwareStatusColor = '#52B35B';
      styles.softwareIcon = <SoftwareHealthIcon color='#52B35B' />;
      break;
    case 'Warning':
      styles.softwareStatusColor = '#EAAB00';
      styles.softwareIcon = <SoftwareHealthIcon color='#EAAB00' />;
      break;
    case 'Error':
      styles.softwareStatusColor = '#D52D34';
      styles.softwareIcon = <SoftwareHealthIcon color='#D52D34' />;
      break;
    default:
      // Default to Healthy case for Cloudport
      styles.softwareStatusColor = '#52B35B';
      styles.softwareIcon = <SoftwareHealthIcon color='#52B35B' />;
      break;
  }

  return styles;
};

const getCardStyling_Uncommissioned = (cloudSystem) => {
  const upTimeDiff = cloudSystem?.lastStatusUpdate ? moment().from(new Date(cloudSystem.lastStatusUpdate), true) : "Undetermined"

  // Set defaults for Uncommissioned
  var styles = {
    textColor: '#FFFFFF',
    secondaryTextColor: '#AEB1B4',
    backgroundColor: '#0A1826',
    borderLeftColor: '#AEB1B4',
    networkHealthText: upTimeDiff,
    networkHealthIcon: <NetworkHealthIcon color='#AEB1B4' />,
    aircraftStatusColor: '#AEB1B4',
    aircraftIcon: <AirplaneOfflineIcon color='#AEB1B4' />,
    softwareStatusColor: '#AEB1B4',
    softwareIcon: <SoftwareOfflineIcon color='#AEB1B4' />,
    contentStatusColor: '#AEB1B4',
    contentIcon: <ContentOfflineIcon color='#AEB1B4' />,
  };

  return styles;
};

const isNetworkOnline = (cloudSystem) => {
  return cloudSystem?.networkHealth === "Healthy";
};